import { UniformSlot } from "@uniformdev/canvas-react";

import { ScrollToEnlarge } from "@/libraries/design/components";

type UniformHeroScrollToEnlargeContainerProps = {
    isTransform?: boolean;
};

const UniformHeroScrollToEnlargeContainer = ({
    isTransform
}: UniformHeroScrollToEnlargeContainerProps) => {
    return (
        <ScrollToEnlarge isTransform={isTransform}>
            <UniformSlot name="content" />
        </ScrollToEnlarge>
    );
};

export default UniformHeroScrollToEnlargeContainer;
